<template>
    <div v-if="!utils.CheckIfNullOrEmpty(local_filter)">
        <div class="rounded-4">
            <div class="mb-1" v-if="showSavedSearchQueries">
                <v-label>{{ $t("res_Label_SavedSearchQueries") }}</v-label>
                <multiselect class="light-bg add-arrow" v-model="selectedSearchItem"
                             :label="language == 'en' ? 'name' : 'nameAr'" track-by="id" open-direction="bottom"
                             :options="savedSearchItems" :searchable="true" :loading="false" @input="savedSearchItemChanged"
                             :allow-empty="true" :internal-search="true" :clear-on-select="false" :close-on-select="true"
                             :options-limit="300" :max-height="600" :show-no-results="false" :hide-selected="false"
                             :multiple="false" ref="multiselect6" :placeholder="$t('res_Label_SelectOption')">
                    <template slot="noOptions">
                        {{ $t('res_Label_ListEmpty') }}
                    </template>
                </multiselect>
            </div>
            <div class="row align-items-center m-0 row g-3">
                <div class="col-md-2 mt-1 p-0">
                    <div @keydown.enter="applyFilters()" class="mt-2 col-12 pl-1 pr-1 pt-0 pb-0">
                        <label class="mb-1">{{ $t("res_Label_Subject") }}</label>
                        <v-text-field v-model="local_filter.subject" type="text" class="search-field light-bg" clearable
                                      :placeholder="$t('res_Placeholder_EnterSubject')"></v-text-field>
                    </div>
                </div>
                <div class="col-md-2 mt-1 p-0">
                    <div @keydown.enter="applyFilters()" class="mt-2 col-12 pl-1 pr-1 pt-0 pb-0">
                        <label class="mb-1">{{ $t("res_MenuItems_ReferenceNumber") }}</label>
                        <v-text-field v-model="local_filter.referenceNumber" type="text" class="search-field light-bg" clearable
                                      :placeholder="$t('res_Placeholder_EnterReference')"></v-text-field>
                    </div>
                </div>

                <div class="col-md-2 mt-1 p-0">
                    <div class="mt-2 col-12 pl-1 pr-1 pt-0 pb-0">
                        <label class="mb-1">{{ $t("res_Label_DocumentSender") }}</label>
                        <StructureUserSelector class="w-100" :showInternalUsers="false" :showExternalUsers="false"
                                               :showInternalStructures="true" :showExternalStructures="true" :excludeSelf="false"
                                               :isMultiple="false" :selectedStructureUser="local_filter.documentSender"
                                               @structureUserSelectChanged="setStructure($event, 3)"
                                               :addressBook_header="$t('res_Label_SelectStructure')">
                            >
                        </StructureUserSelector>
                    </div>
                </div>
                <div class="col-md-2 mt-1 p-0">
                    <div class="mt-2 col-12 pl-1 pr-1 pt-0 pb-0">
                        <label class="mb-1">{{ $t("res_Label_DocumentRecipient") }}</label>
                        <StructureUserSelector class="w-100" :showInternalUsers="false" :showExternalUsers="false"
                                               :showInternalStructures="true" :showExternalStructures="true" :excludeSelf="false"
                                               :isMultiple="false" :selectedStructureUser="local_filter.documentRecipient"
                                               @structureUserSelectChanged="setStructure($event, 4)"
                                               :addressBook_header="$t('res_Label_SelectStructure')">
                        </StructureUserSelector>
                    </div>
                </div>

                <div class="col-md-2 mt-1 p-0">
                    <div class="mt-2 col-12 pl-1 pr-1 pt-0 pb-0">
                        <label class="mb-1">{{ $t("res_Label_CreatedBy") }}</label>
                        <StructureUserSelector class="w-100" :showInternalUsers="true" :showExternalUsers="false"
                                               :showInternalStructures="false" :showExternalStructures="false" :excludeSelf="false"
                                               :isMultiple="false" :selectedStructureUser="local_filter.fromUser"
                                               @structureUserSelectChanged="setUser($event, 3)" :addressBook_header="$t('SelectUser')">
                        </StructureUserSelector>
                    </div>
                </div>
                <div class="col-md-2 mt-1 p-0">
                    <div class="mt-2 col-12 pl-1 pr-1 pt-0 pb-0">
                        <label class="mb-1">{{ $t("res_Label_Priority") }}</label>
                        <multiselect class="light-bg add-arrow mt-1" v-model="local_filter.priorityLevel" :label="language == 'en' ? 'name' : 'nameAr'"
                                     track-by="id" open-direction="bottom" :options="priorities" :searchable="true" :loading="false"
                                     :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                     :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="false"
                                     ref="multiselect1" :placeholder="$t('res_Label_Priority')">
                            <template slot="noOptions">
                                {{ $t('res_Label_ListEmpty') }}
                            </template>
                        </multiselect>
                    </div>
                </div>
                <div class="col-md-2 mt-1 p-0">
                    <div class="mt-2 col-12 pl-1 pr-1 pt-0 pb-0">
                        <label class="mb-1">{{ $t("res_Label_Privacy") }}</label>
                        <multiselect class="light-bg add-arrow mt-1" v-model="local_filter.privacyLevel" :label="language == 'en' ? 'name' : 'nameAr'"
                                     track-by="id" open-direction="bottom" :options="privacies" :searchable="true" :loading="false"
                                     :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                     :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="false"
                                     ref="multiselect2" :placeholder="$t('res_Label_Privacy')">
                            <template slot="noOptions">
                                {{ $t('res_Label_ListEmpty') }}
                            </template>
                        </multiselect>
                    </div>
                </div>

                <div class="col-md-2 mt-1 p-0">
                    <div class=" pl-1 pr-1 pt-0 pb-0 mt-2 col-12">
                        <label class="mb-1">{{ $t("res_Label_Category") }}</label>
                        <multiselect class="light-bg add-arrow" v-model="local_filter.category" :label="language == 'en' ? 'name' : 'nameAr'" track-by="id"
                                     open-direction="bottom" :options="categories" :searchable="false" :internal-search="false"
                                     :clear-on-select="false" :close-on-select="true" :options-limit="300" :max-height="600"
                                     :show-no-results="false" :hide-selected="false" :multiple="false" ref="multiselect3"
                                     :placeholder="$t('res_Label_Category')">
                            <template slot="noOptions">
                                {{ $t('res_Label_ListEmpty') }}
                            </template>
                        </multiselect>
                    </div>
                </div>
                <div class="p-0 col-md-2 mt-1">
                    <div class="mt-2 col-12  pl-1 pr-1 pt-0 pb-0">
                        <label class="mb-1">{{ $t("res_Label_Status") }}</label>
                        <multiselect class="light-bg add-arrow" v-model="local_filter.status" :label="language == 'en' ? 'name' : 'nameAr'" track-by="id"
                                     open-direction="bottom" :options="statuses" :searchable="false" :internal-search="false"
                                     :clear-on-select="false" :close-on-select="true" :options-limit="300" :max-height="600"
                                     :show-no-results="false" :hide-selected="false" :multiple="false" ref="multiselect4"
                                     :placeholder="$t('res_Label_Status')">
                            <template slot="noOptions">
                                {{ $t('res_Label_ListEmpty') }}
                            </template>
                        </multiselect>
                    </div>
                </div>

                <div v-if="enableSearchByContent" class="p-0 col-md-2 mt-1">
                    <div class="mt-2 col-12 pl-1 pr-1 pt-0 pb-0">
                        <label class="mb-1">{{ $t("res_Label_Content") }}</label>
                        <!-- <v-text-field v-model="local_filter.content" type="text" class="search-field w-100 light-bg">
                </v-text-field> -->
                        <div class="row m-0" style="    height: 40px !important;
                            border-radius: 6px;
                            width: 100%;
                            background-color: #eff2f5;">
                            <div class="col-9">
                                <input class="w-100" v-model="local_filter.content" style="outline: none;color:var(--content-color);">
                            </div>
                            <div class="col-3" id="AdvanceSearchFilterContentDiv">
                                <v-select style="margin-top: -5px;cursor: pointer !important;"
                                          v-model="local_filter.contentSelectedYear"
                                          @change="SelectedYearChange"
                                          :items="years"
                                          dense
                                          hide-details>
                                </v-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="p-0 col-md-2 mt-1">
                    <div class="mt-2 col-12  pl-1 pr-1 pt-0 pb-0">
                        <label class="mb-1">{{ $t("res_Label_Content") }}</label>
                        <v-text-field v-model="local_filter.content" type="text" class="search-field w-100 light-bg"
                                      :placeholder="$t('res_Label_Content')"></v-text-field>
                    </div>
                </div>
                <div class="p-0 col-md-2 mt-1" v-if="areTagsEnabled">
                    <div class="mt-2 col-12  pl-1 pr-1 pt-0 pb-0">
                        <label class="mb-1">{{ $t("res_Label_Tags") }}</label>
                        <v-text-field v-model="local_filter.tags" type="text" class="search-field w-100 light-bg" clearable
                                      :placeholder="$t('res_Label_Tags')"></v-text-field>
                    </div>
                </div>
                <div class="p-0 col-md-2 mt-1">
                    <div class="mt-2 col-12 pl-1 pr-1 pt-0 pb-0">
                        <label class="mb-1">{{ $t("res_Label_Links") }}</label>
                        <v-text-field v-model="local_filter.links" type="text" class="search-field w-100 light-bg" clearable
                                      :placeholder="$t('res_Label_Links')"></v-text-field>
                    </div>
                </div>
                <div class="p-0 col-md-2 mt-1">
                    <div class="mt-2 col-12 pl-1 pr-1 pt-0 pb-0">
                        <label class="mb-1">{{ $t("res_Label_Template") }}</label>
                        <multiselect class="light-bg add-arrow" v-model="local_filter.template" label="name" track-by="id"
                                     open-direction="bottom" :options="templates" :searchable="true" :internal-search="true"
                                     :clear-on-select="false" :close-on-select="true" :options-limit="300" :max-height="600"
                                     :show-no-results="false" :hide-selected="false" :multiple="true" ref="multiselect5"
                                     :placeholder="$t('res_Label_Template')">
                            <template slot="noOptions">
                                {{ $t('res_Label_ListEmpty') }}
                            </template>
                        </multiselect>
                    </div>
                </div>
                
                <div class="p-0 col-md-2 mt-1">
                    <div @keydown.enter="applyFilters()" class="mt-2 col-12 pl-1 pr-1 pt-0 pb-0">
                        <label class="mb-1">{{ $t("res_Label_Keywords") }}</label>
                        <v-text-field v-model="local_filter.keywords" type="text" class="search-field w-100 light-bg" clearable
                                      :placeholder="$t('res_Label_Keywords')"></v-text-field>
                    </div>
                </div>
                <!-- <div><div class="p-0 mt-2" v-if="client_version_Id != 'DEG'">
            <label class="mb-1">{{ $t("res_Label_Employee") }}</label>
            <div class="with-absolute-button">
                <multiselect class="light-bg" v-model="local_filter.HrmsEmployee" track-by="id" :label="language == 'en' ? 'name' : 'nameAr'"
                    open-direction="bottom" :options="constants.hrmsEmployeeList" :searchable="true"
                    :loading="loading" :internal-search="true" :clear-on-select="false" :close-on-select="true"
                    :options-limit="300" :max-height="600" :show-no-results="false" :hide-selected="false"
                    :multiple="false" ref="multiselect15" :placeholder="$t('res_Label_SelectOption')"
                    @select="setHrmsEmployeeId">
                    <template slot="noOptions">
                        {{ $t('res_Label_ListEmpty') }}
                    </template>
                </multiselect>
                <button @click="openMultiSelectCtrl(15)"><v-icon>mdi-menu-down</v-icon></button>
            </div>
        </div></div>  -->
                <hr class="mt-3 mb-1">
                <!--From Date-->
                <div class="p-0 col-md-2 mt-1">
                    <div class="mt-2 col-12 pl-1 pr-1 pt-0 pb-0">
                        <label class="mb-1">{{ $t("res_Label_FromDate") }}</label>
                        <v-menu offset-y content-class="p-0" v-model="from_date_datePicker" :close-on-content-click="false">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field :value="utils.dateFormat(local_filter.fromDate)" class="bg-white" :label="$t('res_Label_SelectDate')"
                                              readonly v-bind="attrs" v-on="on" solo append-icon="mdi-calendar" :tabindex="-1"
                                              :placeholder="constants.defaultDateValue">
                                    <template v-slot:append>
                                        <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker id="advanced-date-menu" v-model="local_filter.fromDate"
                                           :max="new Date().toISOString().slice(0, 10)" @input="from_date_datePicker = false"
                                           :locale="language" @change="validateDate('from')"></v-date-picker>
                        </v-menu>
                    </div>
                </div>
                <!--To Date-->
                <div class="p-0 col-md-2 mt-1">
                    <div class="mt-2 col-12 pl-1 pr-1 pt-0 pb-0">
                        <label class="mb-1">{{ $t("res_Label_ToDate") }}</label>
                        <v-menu content-class="p-0" offset-y v-model="to_date_datePicker" :close-on-content-click="false">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field :value="utils.dateFormat(local_filter.toDate)" :label="$t('res_Label_SelectDate')" readonly
                                              v-bind="attrs" v-on="on" solo append-icon="mdi-calendar" :tabindex="-1"
                                              :placeholder="constants.defaultDateValue">
                                    <template v-slot:append>
                                        <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker id="advanced-date-menu" v-model="local_filter.toDate"
                                           :max="new Date().toISOString().slice(0, 10)" @input="to_date_datePicker = false"
                                           :locale="language" @change="validateDate('to')"></v-date-picker>
                        </v-menu>
                    </div>
                </div>
                <!--From Structure-->
                <div class="p-0 col-md-2 mt-1">
                    <div class="mt-2 col-12 pl-1 pr-1 pt-0 pb-0">
                        <label class="mb-1">{{ $t("res_GridHeaders_FromStructure") }}</label>
                        <StructureUserSelector class="w-100" :showInternalUsers="false" :showExternalUsers="false"
                                               :showInternalStructures="true" :showExternalStructures="false" :excludeSelf="false"
                                               :isMultiple="false" :selectedStructureUser="local_filter.fromStructure"
                                               @structureUserSelectChanged="setStructure($event, 1)"
                                               :addressBook_header="$t('res_Label_SelectStructure')">
                        </StructureUserSelector>
                    </div>
                </div>
                <!--To Structure-->
                <div class="p-0 col-md-2 mt-1">
                    <div class="mt-2 col-12 pl-1 pr-1 pt-0 pb-0">
                        <label class="mb-1">{{ $t("res_GridHeaders_ToStructure") }}</label>
                        <StructureUserSelector class="w-100" :showInternalUsers="false" :showExternalUsers="false"
                                               :showInternalStructures="true" :showExternalStructures="false" :excludeSelf="false"
                                               :isMultiple="false" :selectedStructureUser="local_filter.toStructure"
                                               @structureUserSelectChanged="setStructure($event, 2)"
                                               :addressBook_header="$t('res_Label_SelectStructure')">
                        </StructureUserSelector>
                    </div>
                </div>
                <!--From User-->
                <div class="p-0 col-md-2 mt-1">
                    <div class=" mt-2 col-12  pl-1 pr-1 pt-0 pb-0">
                        <label class="mb-1">{{ $t("res_GridHeaders_FromUser") }}</label>
                        <StructureUserSelector class="w-100" :showInternalUsers="true" :showExternalUsers="false"
                                               :showInternalStructures="false" :showExternalStructures="false" :excludeSelf="false"
                                               :isMultiple="false" :selectedStructureUser="local_filter.fromUser"
                                               @structureUserSelectChanged="setUser($event, 1)" :addressBook_header="$t('SelectUser')">
                        </StructureUserSelector>
                    </div>
                </div>
                <!--To User-->
                <div class="p-0 col-md-2 mt-1">
                    <div class="mt-2 col-12 pl-1 pr-1 pt-0 pb-0">
                        <label class="mb-1">{{ $t("res_GridHeaders_ToUser") }}</label>
                        <StructureUserSelector class="w-100" :showInternalUsers="true" :showExternalUsers="false"
                                               :showInternalStructures="true" :showExternalStructures="false" :excludeSelf="false"
                                               :isMultiple="false" :selectedStructureUser="local_filter.toUser"
                                               @structureUserSelectChanged="setUser($event, 2)" :addressBook_header="$t('SelectUser')">
                        </StructureUserSelector>
                    </div>
                </div>
                <!--checkboxes-->
                <div class="p-0 mt-1">
                    <div class="mt-2 col-12 pl-1 pr-1 pt-0 pb-0 d-flex ">
                        <div class="p-0 mt-2 ml-4 mr-4 d-flex align-items-center">
                            <v-checkbox v-model="local_filter.SignedByMe" color="#00ae8d" class="mt-0"></v-checkbox>
                            <label class="mb-1">{{ $t("res_ButtonText_SignedByMe") }}</label>
                        </div>
                        <div class="p-0 mt-2 ml-4 mr-4 d-flex align-items-center">
                            <v-checkbox v-model="local_filter.ArchivedByMe" color="#00ae8d" class="mt-0"></v-checkbox>
                            <label class="mb-1">{{ $t("res_ButtonText_ArchiverByMe") }}</label>
                        </div>
                        <div class="p-0 mt-2 ml-4 mr-4 d-flex align-items-center">
                            <v-checkbox v-model="local_filter.RejectedByMe" color="#00ae8d" class="mt-0"></v-checkbox>
                            <label class="mb-1">{{ $t("res_ButtonText_RejectedByMe") }}</label>
                        </div>
                        <div class="d-flex mt-4 m-left-auto">
                            <v-btn dense @click="applyFilters()" class="primary mr-2">{{ $t("res_ButtonText_Search") }}</v-btn>
                            <v-btn dense @click="addUpdateSearchItemDialog = true" class="primary mr-2"
                                   v-if="showSavedSearchQueries">
                                {{ addUpdateSearchItem.id > 0 ? $t("res_ButtonText_UpdateSearchQuery") : $t("res_ButtonText_SaveSearchQuery") }}
                            </v-btn>
                            <v-btn dense @click="clearFilters()" class="light-blue mr-2">{{ $t("res_Label_ClearAll") }}</v-btn>
                            <v-btn dense @click="showAdvancedSearchDialog()" class="expand-advance-search light-blue mr-2"><v-icon> mdi-chevron-up </v-icon></v-btn>
                        </div>
                    </div>
                </div>
            </div>
            
            <v-dialog v-model="addUpdateSearchItemDialog" max-width="500px">
                <v-card>
                    <v-toolbar class="bg-white">
                        <v-card-title class="p-0">
                            <span v-if="addUpdateSearchItem.id > 0">{{ $t("res_ButtonText_UpdateSearchQuery") }}</span>
                            <span v-else>{{ $t("res_ButtonText_SaveSearchQuery") }}</span>
                        </v-card-title>
                        <v-spacer></v-spacer>
                        <v-btn class="close-btn light-btn" icon dark @click="addUpdateSearchItemDialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <div class="d-flex flex-column overflow-auto h-100">
                        <div class="grid-12 flex-1 p-4 overflow-auto gap-2">
                            <v-row>
                                <v-col cols="12">
                                    <v-label>{{ $t('res_Label_Name') }} *</v-label>
                                    <v-text-field solo v-model="addUpdateSearchItem.name"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-label>{{ $t("res_Label_NameAr") }} *</v-label>
                                    <v-text-field solo v-model="addUpdateSearchItem.nameAr"></v-text-field>
                                </v-col>
                            </v-row>
                        </div>
                        <v-card-actions class="gap-2 sticky-actions">
                            <v-spacer></v-spacer>
                            <v-btn class="light-blue" style="min-width: 100px !important;"
                                   @click="addUpdateSearchItemDialog = false">
                                {{
                                    $t("res_ButtonText_Cancel")
                                }}
                            </v-btn>
                            <v-btn class="primary" style="min-width: 100px !important;" @click="saveSearchQuery()">
                                {{
                                $t("res_ButtonText_Save")
                                }}
                            </v-btn>
                        </v-card-actions>
                    </div>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>
    import StructureUserSelector from '@/components/StructureUserSelector.vue';
    import Multiselect from 'vue-multiselect';
    import constants from '../assets/js/constants.js';
    import * as utils from '../assets/js/common.js'
    import axios from 'axios';
    import { json } from 'd3';

    export default {
        name: 'AdvancedSearchFilters',
        props: {
            filter: { type: Object, default: function () { return {}; } },
            applyFiltersOnReset: { type: Boolean, default: false },
            language: { type: String, default: 'en' }
        },
        components: {
            StructureUserSelector, Multiselect
        },
        data() {
            return {
                enableSearchByContent: window.enableSearchByContent,
                constants: constants,
                utils: utils,
                selectedItem: null,
                selected: [],
                privacies: [],
                priorities: [],
                from_date_datePicker: false,
                to_date_datePicker: false,
                categories: [],
                statuses: [],
                templates: [],
                local_filter: {
                    subject: "",
                    referenceNumber: "",
                    fromDate: "2026-01-01",
                    toDate: "",
                    documentSender: null,
                    documentRecipient: null,
                    fromStructure: null,
                    toStructure: null,
                    fromUser: null,
                    createdBy: null,
                    toUser: null,
                    category: null,
                    privacyLevel: null,
                    priorityLevel: null,
                    note: "",
                    keywords: "",
                    category: null,
                    RejectedByMe: false,
                    ArchivedByMe: false,
                    SignedByMe: false,
                    HrmsEmployee: null,
                    HrmsEmployeeId: 0,
                    contentSelectedYear: new Date().getFullYear(),
                },
                SelectedYear: 0,
                yearMenu: false,
                years: Array.from({ length: new Date().getFullYear() - 2009 }, (_, i) => new Date().getFullYear() - i),
                received_date_datePicker: false,
                loading: false,
                areTagsEnabled: false,
                showSavedSearchQueries: window.showSavedSearchQueries,
                addUpdateSearchItemDialog: false,
                addUpdateSearchItem: {
                    id: 0,
                    name: "",
                    nameAr: "",
                    searchObject: "",
                },
                savedSearchItems: [],
                selectedSearchItem: null,
                client_version_Id: constants.client_version_Id
            }
        },
        mounted() {
            this.resetFilters(false);
            this.getAllSavedSearchItems();
            this.privacies = constants.privacies;
            this.priorities = constants.priorities;
            this.categories = constants.categories;
            this.areTagsEnabled = window.areTagsEnabled;

            // hiding showing canceled and draft document statuses
            this.statuses = constants.statuses.filter(x => x.id != 4 && x.id != 1);

            utils.copyObject(this.filter, this.local_filter);
            this.getTemplates();
        },
        watch: {
            filter: {
                handler(newVal, oldVal) {
                    if (newVal != {}) {
                        this.local_filter = utils.copyObject(newVal, this.local_filter)
                    }
                },
                deep: true
            },
            selectedSearchItem(val) {
                if (val)
                    this.addUpdateSearchItem = utils.copyObject(val, this.addUpdateSearchItem)
                else
                    this.addUpdateSearchItem = { id: 0, name: "", nameAr: "", searchObject: "" }
            }
        },
        methods: {
            // applyAfterReset is false for the reset that runs while the component is
            // mounting: clearing the filters on startup must not trigger a search.
            // The Clear button still calls it with the default (true).
            resetFilters(applyAfterReset = true) {
                this.selectedSearchItem = null

                this.local_filter = {
                    subject: "",
                    referenceNumber: "",
                    fromDate: "2026-01-01",
                    toDate: "",
                    documentSender: null,
                    documentRecipient: null,
                    fromStructure: null,
                    toStructure: null,
                    fromUser: null,
                    createdBy: null,
                    toUser: null,
                    category: null,
                    privacyLevel: null,
                    priorityLevel: null,
                    status: null,
                    receivedDate: "",
                    content: "",
                    contentSelectedYear: new Date().getFullYear(),
                    tags: "",
                    links: "",
                    template: [],
                    note: "",
                    category: null,
                    RejectedByMe: false,
                    ArchivedByMe: false,
                    SignedByMe: false,
                    keywords: "",
                }

                if (applyAfterReset && this.applyFiltersOnReset)
                    this.applyFilters();
            },
            getTemplates() {
                axios.post(constants.baseApiUrl + 'Template/GetAllTemplates', null)
                    .then(response => {
                        if (response && response.data.length > 0) {
                            this.templates = response.data;
                        }
                    })
                    .catch(error => console.log(error))
                    .finally(() => this.loading = false);
            },
            getTemplates1() {
                var requestObj = {
                    "CategoryId": 0,
                    "Language": "",
                    "Privacy": -1,
                    "Search": "",
                    "SignatureCount": -1,
                    "StructureId": 0,
                    "Tags": ""
                }

                window.showLoading();
                axios.post(constants.baseApiUrl + 'Template/SearchTemplates', requestObj, { headers: constants.headers })
                    .then(response => {
                        if (response.data != null && response.data != undefined) {
                            this.templates = response.data;
                        }
                    })
                    .catch(error => console.log(error))
                    .finally(() => window.hideLoading())
            },
            applyFilters() {
                this.local_filter.enableAdvancedSearch = true;
                this.$emit('applyFilters', this.local_filter);
            },
            clearFilters() {
                this.resetFilters();
            },
            setStructure(item, type) {
                switch (type) {
                    case 1:
                        this.local_filter.fromStructure = item;
                        break;
                    case 2:
                        this.local_filter.toStructure = item;
                        break;
                    case 3:
                        this.local_filter.documentSender = item;
                        break;
                    case 4:
                        this.local_filter.documentRecipient = item;
                        break;
                }
            },
            setUser(selectedUserItem, type) {
                const value = selectedUserItem == null ? null : { ...selectedUserItem, id: selectedUserItem.id.toString().split('-')[0] };
                if (type == 1) this.local_filter.fromUser = value;
                else if (type == 2) this.local_filter.toUser = value;
                else this.local_filter.createdBy = value;
            },
            validateDate(dateToRemove) {
                if (this.local_filter.fromDate && this.local_filter.toDate) {
                    if (this.local_filter.fromDate > this.local_filter.toDate) {
                        window.showAlert("res_Msgs_FromDateCompare", "warning");
                        if (dateToRemove == 'to') {
                            this.local_filter.toDate = ''
                        } else {
                            this.local_filter.fromDate = "2026-01-01"
                        }
                    }
                }
            },
            openMultiSelectCtrl(id) {
                // for AdPorts
                if (id === 15) this.$refs.multiselect15.activate()
            },
            setHrmsEmployeeId(selectedItem) {
                this.local_filter.HrmsEmployeeId = selectedItem.id;
            },
            getAllSavedSearchItems() {
                axios.get(constants.baseApiUrl + 'Search/GetAllSavedSearchQueries')
                    .then(response => {
                        if (response && response.data.length > 0) {
                            this.savedSearchItems = response.data;
                        }
                    })
                    .catch(error => console.log(error))
                    .finally(() => this.loading = false);
            },
            saveSearchQuery() {
                if (this.addUpdateSearchItem.name.trim() == "" || this.addUpdateSearchItem.nameAr.trim() == "") {
                    window.showAlert('res_Msgs_FillRequired', 'warning')
                    return;
                }
                window.showLoading();
                this.addUpdateSearchItem.searchObject = JSON.stringify(this.local_filter);
                axios.post(constants.baseApiUrl + 'Search/SaveSearchQuery', this.addUpdateSearchItem)
                    .then((res) => {
                        this.addUpdateSearchItemDialog = false;
                        if (res.data > 0) {
                            window.showAlert('res_Msgs_SaveSearchQuerySuccess', 'success')
                            this.getAllSavedSearchItems();
                        }
                        else
                            window.showAlert('res_Msgs_SaveSearchQueryError', 'error')
                    })
                    .catch((err) => console.log("Error creating item:", err))
                    .finally(() => window.hideLoading())
            },
            savedSearchItemChanged() {
                this.local_filter = JSON.parse(this.selectedSearchItem.searchObject);
            },
            SelectedYearChange($event) {

            },
            showAdvancedSearchDialog(){
                this.$emit('showAdvancedSearchDialogEvent')
            },
        }
    }
</script>

<style>
    #AdvanceSearchFilterContentDiv .v-icon.notranslate.mdi.mdi-menu-down.theme--light {
        display: none !important;
    }

    #AdvanceSearchFilterContentDiv .v-input__append-inner {
        display: none !important;
    }

    #AdvanceSearchFilterContentDiv .v-select__selection.v-select__selection--comma {
        color: #667593 !important;
    }
</style>